import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { IpAddressService } from 'src/app/services/ip-address.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-import-bank-data',
  templateUrl: './import-bank-data.component.html',
  styleUrls: ['./import-bank-data.component.scss'],
})
export class ImportBankDataComponent implements OnInit {
  xslxToJsonData: any[] = [];
  uploadFile: any;
  cols: any;
  showViewDocDialog: boolean = false;
  sheetName: any;

  ipAddress: any = '000.000.000';

  constructor(
    private messageService: MessageService,
    private ipService: IpAddressService
    ) {}

  ngOnInit(): void {
    this.getIP();
  }

  onUpload(event, formcontrol, uploadElement) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    let file = event.files[0];
    this.uploadFile = file;
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        this.sheetName = workBook.SheetNames
        initial[name] = XLSX.utils.sheet_to_json(sheet,
          {raw: false,
          header: name ? 0 : 1,
          dateNF:'mm/dd/yyyy;@'}
          );
        return initial;
      }, {});
      let sheetName = this.sheetName[0];
      const dataString = JSON.stringify(jsonData);
      this.xslxToJsonData = JSON.parse(dataString)[sheetName];
      // this.xslxToJsonData.forEach(value => {
        // value['Value Date'] = new Date(value['Value Date'])
      // })
      if (!this.xslxToJsonData) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail:
            'The Uploaded file has invalid data "or" Multiple sheet data is not supported!',
        });
      }
    };
    reader.readAsBinaryString(file);
    uploadElement.clear();
  }

  onOpenDialog() {
    this.cols = [];
    let colHeaders = Object.keys(this.xslxToJsonData[0]);
    colHeaders.forEach((elem) => {
      this.cols.push({ field: elem, header: elem });
    });
    this.showViewDocDialog = true;
  }

  clearUpload() {
    // this.applicationSelected = undefined;
    this.xslxToJsonData = [];
  }

  onCloseDialog() {
    this.showViewDocDialog = false;
  }

  submitApplication() {
    // Construct the Request Body
    let body = [];

    let jsonList = [];
    this.xslxToJsonData.forEach((obj) => {
      jsonList.push({
        postingDate: obj['Posting date'] ? obj['Posting date'] : 0,
        accountNo: obj['Account No'] ? obj['Account No'] : 0,
        clientCode: obj['Client code'] ? obj['Client code'] : 0,
        clientName: obj['Client name'] ? obj['Client name'] : 0,
        referenceNo: obj['Reference No.'] ? obj['Reference No.'] : 0,
        amount: obj['Amount'] ? obj['Amount'] : 0,
        remitterAccount: obj['Remitter Account'] ? obj['Remitter Account'] : 0,
        remitterName: obj['Remitter Name'] ? obj['Remitter Name'] : 0,
        remitterBank: obj['Remitter Bank'] ? obj['Remitter Bank'] : 0,
        remitterIFSC: obj['Remitter IFSC'] ? obj['Remitter IFSC'] : 0,
        challanType: obj['Challan Type'] ? obj['Challan Type'] : 1
      });
    });
    let reqBody = {
      list: jsonList,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress,
    };
    body.push(reqBody);
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }
}
